var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImages = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 250 200"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F9FAFB",
  fillRule: "evenodd",
  d: "M63 134h91q.774-.002 1.5-.161.726.16 1.5.161h52a7 7 0 1 0 0-14h-6a7 7 0 1 1 0-14h19a7 7 0 1 0 0-14h-22a7 7 0 1 0 0-14h-64a7 7 0 1 0 0-14H79a7 7 0 1 0 0 14H39a7 7 0 1 0 0 14h25a7 7 0 1 1 0 14H24a7 7 0 1 0 0 14h39a7 7 0 1 0 0 14m163 0a7 7 0 1 0 0-14 7 7 0 0 0 0 14",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m86.279 139.123-4.07.572a4 4 0 0 1-4.518-3.404L66.557 57.069a4 4 0 0 1 3.404-4.518l78.231-10.994a4 4 0 0 1 4.518 3.404l.957 6.808",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#F9FAFB",
  fillRule: "evenodd",
  d: "m88.805 134.712-3.696.526a3.62 3.62 0 0 1-4.096-3.085l-9.996-71.925a3.646 3.646 0 0 1 3.098-4.108l71.037-10.096a3.62 3.62 0 0 1 4.097 3.085l.859 6.18 9.205 66.599c.306 2.212-1.22 4.257-3.408 4.566l-.07.009z",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#374151",
  strokeLinecap: "round",
  strokeWidth: 3,
  d: "m86.279 139.123-4.07.572a4 4 0 0 1-4.518-3.404L66.557 57.069a4 4 0 0 1 3.404-4.518l78.231-10.994a4 4 0 0 1 4.518 3.404l.957 6.808"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#374151",
  strokeLinecap: "round",
  strokeWidth: 2.5,
  d: "m154.5 56.38.5 3.12"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#374151",
  strokeWidth: 3,
  d: "M100.07 60.515a2.5 2.5 0 0 1 2.748-2.226l78.567 8.258a2.5 2.5 0 0 1 2.225 2.748l-8.362 79.562a2.5 2.5 0 0 1-2.748 2.225l-78.567-8.258a2.5 2.5 0 0 1-2.225-2.748z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M106.693 69.255a3 3 0 0 1 3.297-2.67l62.655 6.585a3 3 0 0 1 2.67 3.297l-5.54 52.71a3 3 0 0 1-3.297 2.67l-62.655-6.586a3 3 0 0 1-2.67-3.297z",
  clipRule: "evenodd"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#F9FAFB",
  fillRule: "evenodd",
  d: "m109.741 109.878 9.797-6.608a4 4 0 0 1 5.168.594l7.173 7.723c.358.385.954.427 1.363.096l15.339-12.43a4 4 0 0 1 5.878.936l9.981 15.438 1.433 2.392-.686 8.124a1 1 0 0 1-1.107.91l-56.963-6.329a1 1 0 0 1-.885-1.085l.755-8.199z",
  clipRule: "evenodd"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  stroke: "#374151",
  strokeWidth: 3,
  d: "M108.185 69.411a1.5 1.5 0 0 1 1.649-1.335l62.654 6.586a1.5 1.5 0 0 1 1.335 1.648l-5.54 52.71a1.5 1.5 0 0 1-1.648 1.335l-62.655-6.585a1.5 1.5 0 0 1-1.335-1.649z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 122.032,
  cy: 85.95,
  r: 6,
  fill: "#F9FAFB",
  stroke: "#374151",
  strokeWidth: 3,
  transform: "rotate(6 122.032 85.95)"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  stroke: "#374151",
  strokeLinecap: "round",
  strokeWidth: 3,
  d: "m107.729 111.425 11.809-8.155a4 4 0 0 1 5.168.594l7.173 7.723c.359.385.954.427 1.363.096l15.34-12.43a4 4 0 0 1 5.877.937l11.064 17.556"
})));
export default SvgImages;